import React from "react";
import "./Other.css";
import agriculture from "./image/Agriculture-Industry.jpg";
import asphalt from "./image/Asphalt-Manufacturing.jpg";
import bakeries from "./image/Bakeries.jpg";
import escalator from "./image/Escalator-Industry.jpg";
import food from "./image/Food-Processing-Industry.jpg";

const Other = () => {
  return (
    <div>
      <div className="otherp">
        <p className="p">Other Industry</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Other</p> */}
        </div>
      </div>

      <div className="other">
        <div className="auimg">
          <figure>
            <img src={agriculture} alt="chain type 1" />
            <figcaption>Agriculture Industry</figcaption>
          </figure>
        </div>

        <div className="oimg">
          <figure>
            <img src={asphalt} alt="chain type 2" />
            <figcaption>Asphalt Manufacturing</figcaption>
          </figure>
        </div>

        <div className="oimg">
          <figure>
            <img src={bakeries} alt="chain type 3" />
            <figcaption>Bakeries</figcaption>
          </figure>
        </div>

        <div className="oimg">
          <figure>
            <img src={escalator} alt="chain type 4" />
            <figcaption>Escalator Industry</figcaption>
          </figure>
        </div>
      </div>

      <div className="other-two">
        <div className="oimg">
          <figure>
            <img src={food} alt="chain type 5" />
            <figcaption>Food Processing Industry</figcaption>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default Other;
